import {BrowserRouter} from "react-router-dom";
import {Container} from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import {NavHashLink} from "react-router-hash-link";
import Illustration from "../../assets/regular_icons/undraw_welcoming_re_x0qo.svg";
import linkedin from "../../assets/contact_icons/linkedin.svg";
import githubIcon from "../../assets/contact_icons/github.svg";
import hashnodeIcon from "../../assets/contact_icons/hashnode.svg";
import Hello from "../../assets/regular_icons/Hello.gif";
import stackOverflowIcon from "../../assets/contact_icons/stackoverflow.svg";
import {useState, useEffect} from "react";

const TypingEffect = ({texts, speed = 100, delay = 2000}: { texts: string[], speed: number, delay: number }) => {
    const [displayedText, setDisplayedText] = useState("");
    const [textIndex, setTextIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentText = texts[textIndex];
        if (!isDeleting && charIndex < currentText.length) {
            const timeout = setTimeout(() => {
                setDisplayedText((prev) => prev + currentText[charIndex]);
                setCharIndex((prev) => prev + 1);
            }, speed);
            return () => clearTimeout(timeout);
        } else if (isDeleting && charIndex > 0) {
            const timeout = setTimeout(() => {
                setDisplayedText((prev) => prev.slice(0, -1));
                setCharIndex((prev) => prev - 1);
            }, speed / 2);
            return () => clearTimeout(timeout);
        } else {
            const timeout = setTimeout(() => {
                setIsDeleting(!isDeleting);
                if (!isDeleting) {
                    setTextIndex((prev) => (prev + 1) % texts.length);
                }
            }, delay);
            return () => clearTimeout(timeout);
        }
    }, [charIndex, isDeleting, textIndex, texts, speed, delay]);

    return <h3>{displayedText ?? " "}<span className="blinking-cursor">|</span></h3>;
};

export function Hero() {


    function calculateTimeCompleted(startYear: number, startMonth: number) {
        const startDate = new Date(startYear, startMonth - 1); // Months are 0-based
        const currentDate = new Date();

        let years = currentDate.getFullYear() - startDate.getFullYear();
        let months = currentDate.getMonth() - startDate.getMonth();

        if (months < 0) {
            years -= 1;
            months += 12;
        }

        return `${years}`;
        // ${months} //for months
    }


    return (
        <Container id="home">
            <div className="hero-text">
                <ScrollAnimation animateIn="fadeInUp">
                    <p className="flex items-baseline gap-2">
                        Hello <img src={Hello} alt="Hello" width="20px"/>,
                    </p>
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
                    <h1>I'm Tilak Ved</h1>
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
                    <TypingEffect texts={["Frontend Developer", "React Developer", "Angular Developer"]}
                                  speed={100} delay={1000}/>

                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
                    <p className="small-resume">{calculateTimeCompleted(2022, 1)}+ Years of Experience</p>
                    <p className="small-resume">Find me on my social</p>
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeInUp block" delay={0.8 * 1000}>
                    <BrowserRouter>
                        <NavHashLink smooth to="#contact" className="button block w-fit">
                            Contact
                        </NavHashLink>
                    </BrowserRouter>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" delay={1 * 1000}>
                    <div className="social-media">
                        <a
                            href="https://www.linkedin.com/in/tilakved"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={linkedin} alt="Linkedin"/>
                        </a>
                        <a
                            href="https://github.com/tilakved"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={githubIcon} alt="GitHub"/>
                        </a>
                        <a
                            href="https://stackoverflow.com/users/17829645/tilak-ved"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={stackOverflowIcon} className="stackOverflowIcon" alt="Stack Overfflow"/>
                        </a>
                        <a
                            href="https://hashnode.com/@tilakved3898"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={hashnodeIcon} className="hashnodeIcon" alt="Hashnode"/>
                        </a>

                    </div>
                </ScrollAnimation>
            </div>

            <div className="hero-image">
                <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
                    <img src={Illustration} alt="Hello there"/>
                </ScrollAnimation>
            </div>
        </Container>
    );
}
